// /**
//  * Created by Administrator on 2018/6/5.
//  */
//
(function ($) {
  $.fn.extend({
    "uploadManager":null,
     "preFileType":0,
    "initUploaderManager": function (fileType,getTokenComplete,startCallback,Progress,completeCallback) {
       if(this.preFileType != fileType){
           this.uploadManager = null;
           this.preFileType = fileType;
       }
       this.uploadManager = new VODUpload({
          // 文件上传失败
          'onUploadFailed': function (uploadInfo, code, message) {
            completeCallback(false,code,message);
            console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message);
          },
          // 文件上传完成
          'onUploadSucceed': function (uploadInfo) {
            completeCallback(true,0,uploadInfo);
            console.log("complete:",uploadInfo);
            console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
          },
          // 文件上传进度
          'onUploadProgress': function (uploadInfo, totalSize, uploadedSize) {
            var res = {
               size : totalSize,
               loaded : uploadedSize,
               percent:Math.ceil(uploadedSize * 100 / totalSize)
            }
            Progress && Progress(res)
            console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(uploadedSize * 100 / totalSize) + "%");
          },
          // STS临时账号会过期，过期时触发函数
          'onUploadTokenExpired': function () {
            var that = this
            console.log("onUploadTokenExpired");
            var httpServer = API.GetAliToken;
            this.ajax({
              url: httpServer,
              success: function (data) {
                if (data.code == 0) {
                  const stsToken = data;
                  that.uploadManager.resumeUploadWithToken(stsToken.data.AccessKeyId, stsToken.data.AccessKeySecret, stsToken.data.SecurityToken, stsToken.data.Expiration);
                }
              },
            });
          },
          // 开始上传
          'onUploadstarted': function (uploadInfo) {
            startCallback()
            console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
          }
        });
        const that = this
      var httpServer = API.GetAliToken;
        // var httpServer =  "http://t.api.ishow.cctv.com/Uploadali/getStsToken";
        this.ajax({
          url: httpServer,
          data:{file_type : fileType},
          success: function (data) {
            if (data.code == 0) {
              const stsToken = data;
              console.log(data);
              that.uploadManager.init(stsToken.data.AccessKeyId, stsToken.data.AccessKeySecret, stsToken.data.SecurityToken, stsToken.data.Expiration);
               getTokenComplete( data )
            }else {
               getTokenComplete(null)
            }
          },
        });
    },
    "uploadHandle":function ( content , startUpload, Progress , complete) {
      var that = this
      var key = content.file.name;   //文件总名
      var name = key.split('.');
      var ext = name[name.length-1].toLowerCase();
      var cookieArrays = document.cookie.split(";")
      var verifyCode =  "";
      for (var cookieIndex  in  cookieArrays){
           var cookieString = cookieArrays[cookieIndex]
          if(cookieString.indexOf("verifycode") !== -1) {
              verifyCode = cookieString.split("=")[1];
              break;
          }
      }
      var userData = {
        "Vod": {
          "UserData": {
            "title": content.Biography.title,
            "description": content.Biography.description,
            "activity_id": content.Biography.activity_id,
            "source": content.Biography.source,
            "audit_level": content.Biography.audit_level,
            "app_id": content.Biography.app_id,
            "file_type": content.file_type,
            "verifycode":verifyCode
          }
        }
      }
      this.initUploaderManager( content.file_type,function (res) {

          if(res != null){
            const info = res.data;
            userData.Vod.UserData.file_type = info.file_type;
            userData.Vod.UserData.file_id = info.file_id;
            userData.Vod.UserData.user_id = info.user_id;
            userData.Vod.UserData.user_name = info.user_name;

            const endPoint = "https://" + info.endpoint;
            const bucket = "hudong-ishow";
            const object = info.pre_dir + info.file_id + "." + ext;
            console.log("userData：",userData,endPoint,bucket,object)
            that.uploadManager.addFile(content.file,endPoint,bucket,object,JSON.stringify(userData));
            that.uploadManager.startUpload();
          }else{
              complete(false,-99,"获取token失败，请重新上传")
          }
      },function () {
          startUpload()
      },Progress,complete)
     },
    "cancleUploadFile":function () {
       this.uploadManager.cancelFile(0);
    },
    "deleteUploadFile":function () {
       this.uploadManager.deleteFile(0);
    },
    "stopUploadFile":function () {
      this.uploadManager.stopUpload();
    },
    "ajax": function (opts) {
      var browser = navigator.appName
      var b_version = navigator.appVersion
      var version = b_version.split(";");
      if (version[1] != undefined) {
        var trim_Version = version[1].replace(/[ ]/g, "");
      }
      if (opts.type && browser == "Microsoft Internet Explorer" && (trim_Version == "MSIE8.0" || trim_Version == "MSIE9.0")) {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", opts.url, true);
        xhr.withCredentials = true; //支持跨域发送cookies
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        var sendName = "";

        if (opts.data != undefined) {
          if (typeof opts.data == "object") {
            for (var o in opts.data) {
              sendName += o + "=" + opts.data[o] + "&"
            }
          } else {
            sendName = opts.data
          }
        }
        xhr.send(sendName);
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4) {
            var txt = xhr.responseText;
            console.log(txt)
            opts.success && opts.success(JSON.parse(txt));
          }
        }
      } else {
        // jQuery.support.cors = true
        var dataType = opts.dataType || 'json'
        if (browser == "Microsoft Internet Explorer" && (trim_Version == "MSIE8.0" || trim_Version == "MSIE9.0")) {
          dataType = 'jsonp'
        }
        $.ajax({
          url: opts.url,
          type: opts.type || 'get',
          dataType: dataType,
          jsonp: opts.jsonp || 'jsoncallback',
          data: opts.data,
          xhrFields: {
            withCredentials: true // 这里设置了withCredentials
          },
          beforeSend: function (XHR) {
            opts.beforeSend && opts.beforeSend(XHR);
          },
          success: function (data) {
            opts.success && opts.success(data);
          },
          complete: function (event, xhr, options) {
            opts.complete && opts.complete(event);
          },
          error: function (xhr, errormsg, event) {
            opts.error && opts.error(xhr, errormsg, event);
          }
        })
      }
    }
  })
})(jQuery)
// (function ($) {
//   $.fn.extend({
//))"uploadHandle": function (content) {
//       var data = null;
//       var key = content.file.name;        //文件总名
//       var name = key.split('.');  // 截取
//       var ext = name[name.length - 1].toLowerCase();
//
//       var params = key.split('.')[0]; //文件名
//       var domain = 'upload-cc';  //域名
//       var appServer = 'http://t.api.ishow.cctv.com/Uploadali/getStsToken?file_type=' + content.file_type;
//       var bucket = 'hudong-ishow';
//       var region = 'oss-cn-beijing';
//
//
//       var userData = {
//         "Vod": {
//           "UserData": {
//             "title": content.Biography.title,
//             "description": content.Biography.description,
//             "activity_id": content.Biography.activity_id,
//             "source": content.Biography.source,
//             "audit_level": content.Biography.audit_level,
//             "app_id": content.Biography.app_id,
//             "file_type": content.file_type,
//           }
//         }
//       }
//
//       this.applyTokenDo(appServer, function (creds) {
//
//         userData.Vod.UserData.file_id = creds.file_id;
//         var OSS = require('ali-oss');
//         var client = OSS({
//           region: region,
//           accessKeyId: creds.AccessKeyId,
//           accessKeySecret: creds.AccessKeySecret,
//           stsToken: creds.SecurityToken,
//           bucket: bucket
//         });
//         console.log(client);
//         var headers = {'x-oss-notification': new Buffer(JSON.stringify(userData)).toString('base64')}
//         console.log(headers);
//         client.multipartUpload(creds.pre_dir + creds.file_id, content.file, {
//           partSize: 1048576,
//           progress: function (p) {
//             return function (done) {
//               console.log("progress:", p, Math.floor(p * 100))
//               done();
//             }
//           },
//           headers: headers
//         }).then(function (res) {
//           console.log('upload success: %j', res);
//           // callback || callback(res)
//         });
//       })
//       //
//       // if (!content.uuid) {
//       //     data = {
//       //         code: 1,
//       //         msg: '网络错误（请求上传token失败），请关闭弹窗刷新页面'
//       //     };
//       //     callback && callback(data);
//       //     return false;
//       // } else if (!content.token) {
//       //     data = {
//       //         code: 1,
//       //         msg: '网络错误（请求上传token失败），请关闭弹窗刷新页面'
//       //     };
//       //     callback && callback(data);
//       //     return false
//       // } else {
//       //
//       //     call && call(data)
//       // }
//
//     },
//     "applyTokenDo": function (appServer, getTokenCompelete) {
//       this.ajax({
//         url: appServer,
//         success: function (data) {
//           if (data.code == 0) {
//             console.log(data);
//             const creds = data.data;
//             console.log(creds);
//             getTokenCompelete(creds)
//           }
//         },
//         error: function (xhr, errormsg, event) {
//
//         }
//       });
//     },
//     "ajax": function (opts) {
//       var browser = navigator.appName
//       var b_version = navigator.appVersion
//       var version = b_version.split(";");
//       if (version[1] != undefined) {
//         var trim_Version = version[1].replace(/[ ]/g, "");
//       }
//       if (opts.type && browser == "Microsoft Internet Explorer" && (trim_Version == "MSIE8.0" || trim_Version == "MSIE9.0")) {
//         var xhr = new XMLHttpRequest();
//         xhr.open("POST", opts.url, true);
//         xhr.withCredentials = true; //支持跨域发送cookies
//         xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
//         var sendName = "";
//
//         if (opts.data != undefined) {
//           if (typeof opts.data == "object") {
//             for (var o in opts.data) {
//               sendName += o + "=" + opts.data[o] + "&"
//             }
//           } else {
//             sendName = opts.data
//           }
//         }
//         xhr.send(sendName);
//         xhr.onreadystatechange = function () {
//           if (xhr.readyState == 4) {
//             var txt = xhr.responseText;
//             console.log(txt)
//             opts.success && opts.success(JSON.parse(txt));
//           }
//         }
//       } else {
//         // jQuery.support.cors = true
//         var dataType = opts.dataType || 'json'
//         if (browser == "Microsoft Internet Explorer" && (trim_Version == "MSIE8.0" || trim_Version == "MSIE9.0")) {
//           dataType = 'jsonp'
//         }
//         $.ajax({
//           url: opts.url,
//           type: opts.type || 'get',
//           dataType: dataType,
//           jsonp: opts.jsonp || 'jsoncallback',
//           data: opts.data,
//           xhrFields: {
//             withCredentials: true // 这里设置了withCredentials
//           },
//           beforeSend: function (XHR) {
//             opts.beforeSend && opts.beforeSend(XHR);
//           },
//           success: function (data) {
//             opts.success && opts.success(data);
//           },
//           complete: function (event, xhr, options) {
//             opts.complete && opts.complete(event);
//           },
//           error: function (xhr, errormsg, event) {
//             opts.error && opts.error(xhr, errormsg, event);
//           }
//         })
//       }
//     }
//   })
// })(jQuery)



//////////////////
// WEBPACK FOOTER
// ./static/lib/upload.js
// module id = 8Txb
// module chunks = 0